/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "AdminQueries",
            "endpoint": "https://6fk5n5goo4.execute-api.us-east-1.amazonaws.com/tmobilestg",
            "region": "us-east-1"
        },
        {
            "name": "TMOAmplifyApi",
            "endpoint": "https://qgrkkpwbp4.execute-api.us-east-1.amazonaws.com/tmobilestg",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:84ec3c8f-318f-40e0-b97c-e8b70648dc2b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_qRumRDBLa",
    "aws_user_pools_web_client_id": "5m0ghp37km8mtal1e7j7n93us4",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL",
        "FAMILY_NAME",
        "GIVEN_NAME"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "tmo-content135501-tmobilestg",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
